import api, { baseURL } from "../../../../utils/api";

const getV2Base = () => {
  try {
    return new URL(baseURL || "").origin;
  } catch {
    return baseURL || "";
  }
};

const V2_BASE = getV2Base();
const PATH = "/api/v2/cms/users";

const getAuthHeader = () => {
  const token = localStorage.getItem("ProlegionAccessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCmsUsers = (pageIndex = 1, pageSize = 10) => {
  return api.get(`${V2_BASE}${PATH}`, {
    params: { pageIndex, pageSize },
    headers: getAuthHeader(),
  });
};

export const updateCmsUserStatus = (id, cmsAccess) => {
  return api.put(`${V2_BASE}${PATH}/${id}/enable-disable`, { cmsAccess }, {
    headers: getAuthHeader(),
  });
};

export const assignRoles = (email, roles) => {
  return api.post(`${V2_BASE}${PATH}/assign-roles`, { email, roles }, {
    headers: getAuthHeader(),
  });
};

export const deleteCmsUser = (id) => {
  return api.delete(`${V2_BASE}${PATH}/${id}`, {
    headers: getAuthHeader(),
  });
};
